export function setGuestUser() {
    const { gtag } = useGtag();

    let guest_id = localStorage.getItem('guest_id');
    if (!guest_id) {
        guest_id = `guest_${Date.now()}`;
        localStorage.setItem('guest_id', guest_id);
    }

    gtag('set', { user_id: null });

    gtag('set', 'user_properties', {
        user_type: 'guest',
        is_logged_in: false,
        guest_id
    });
}

export function setLoggedInUser(user: { id: string; email: string; phone: number }) {
    const { gtag } = useGtag();
    const guest_id = localStorage.getItem('guest_id') ?? null;

    gtag('set', { user_id: user.id ?? null });

    gtag('set', 'user_properties', {
        user_type: 'logged_in',
        is_logged_in: true,
        guest_id
    });
}
